import React from 'react';
import { css } from 'emotion';

export const SelectValueContainer = (props) => {
    const {
        selectProps,
        children,
        className,
        cx,
        isMulti,
        getStyles,
        hasValue,
    } = props;

    return (
        <div
            className={cx(
                css(getStyles('valueContainer', props)),
                {
                    'value-container': true,
                    'value-container--is-multi': isMulti,
                    'value-container--has-value': hasValue,
                },
                className,
            )}
            data-testid={selectProps?.testIds?.ValueContainer}
        >
            {children}
        </div>
    );
};
